module.exports = __webpack_public_path__ + "e3f02630c0f76ad039da99f5d518fcc0.svg";